module.exports = __webpack_public_path__ + "img/WT-navimg.ad045e7d.png";